<div class="container about">
    <div class="row justify-content-between align-items-center flex-row-reverse g-4">
        <div class="col-md-7 col-lg-5">
            <div class="about-text">
                <h3>Develop software solutions that leave a lasting impact on your users.</h3>

                <p>
                    With a deep passion for full-stack engineering, I've overseen diverse software projects from concept
                    to
                    completion. My expertise lies in blending coding skills with strategic insight, ensuring top-notch
                    solutions
                    for both web and backend platforms. Engaging closely with clients, I prioritize their vision in
                    every solution
                    I craft.
                </p>

                <div class="social-icon">
                    <a href="https://www.linkedin.com/in/donart-pllashniku/" aria-label="LinkedIn" target="_blank"
                        rel="noopener">
                        <i class="fab fa-linkedin-in"></i>
                    </a>
                    <a href="https://www.facebook.com/donart.pllashniku/" aria-label="Facebook" target="_blank"
                        rel="noopener">
                        <i class="fab fa-facebook-f"></i>
                    </a>
                    <a href="https://www.instagram.com/donartpll/" aria-label="Instagram" target="_blank"
                        rel="noopener">
                        <i class="fab fa-instagram"></i>
                    </a>
                </div>
            </div>
        </div>

        <div class="col-md-5 d-flex justify-content-center align-items-center">
            <div class="about-photo">
                <img src="assets/img/LastD.png" alt="Donart" />
            </div>
        </div>
    </div>
</div>